import { Padded } from '../layout/column';

type HeaderSectionProps = {
  children: React.ReactNode;
};

export function HeaderSection({ children }: HeaderSectionProps) {
  return (
    <section className='header-row flex justify-center bg-primary text-primary-foreground w-full border-b'>
      <Padded className='max-w-viewport w-full flex flex-col sm:flex-row items-center gap-2 py-2'>{children}</Padded>
    </section>
  );
}
